import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { STATS } from "../data/content";

export const Hero = () => (
  <section className="hero" id="home" data-testid="hero-section">
    <div className="wrap hero-inner">
      <h1 className="hero-h1" data-testid="hero-headline">
        <span className="eyebrow" data-testid="hero-eyebrow">
          <span className="sq" /> Creative &amp; Branding Agency · India
        </span>
        <span className="hero-title">
          We Build Brands<br />That People <span className="pink">Remember.</span>
        </span>
      </h1>
      <Reveal delay={160}>
        <p className="hero-sub" data-testid="hero-subhead">
          KR Studio is a creative growth studio founded by Roohi Maryam and Kafeel Rabbani. We help startups
          and established brands grow through branding, social media, performance marketing, video and
          AI-powered creative, as an extension of your team.
        </p>
      </Reveal>
      <Reveal delay={240}>
        <div className="hero-actions">
          <a href="#work" className="btn btn-primary" data-testid="hero-see-work-btn">
            See our work <ArrowUpRight size={17} strokeWidth={2.5} />
          </a>
          <Link to="/contact" className="btn btn-outline" data-testid="hero-start-project-btn">
            Start a project
          </Link>
        </div>
      </Reveal>
      <Reveal delay={320}>
        <div className="hero-stats" data-testid="hero-stats">
          {STATS.map((s) => (
            <div className="hero-stat" key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <div className="num">
                {s.num}
                <span className="pink">+</span>
              </div>
              <div className="label">{s.label}</div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
